import "./CommonAutocomplete.scss";

import { TextField } from "@material-ui/core";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import React from "react";

export const CommonAutocomplete = ({
  id,
  placeholder,
  values,
  errors,
  touched,
  setFieldValue,
  options,
  showIcon,
  getIcon,
  disabled,
  className,
  ...props
}: any) => {
  // Options
  const baseFilter = createFilterOptions({ matchFrom: "start" });

  const getOptionLabel = (option: any) => {
    return option ? option.label : "";
  };

  const adaptStateForFilter = (state: any) => {
    return {
      ...state,
      getOptionLabel,
    };
  };

  const filterOptions = (
    options: any, state: any
  ) =>
    baseFilter(
      options,
      adaptStateForFilter(state)
    );

  const isValidationFailed = errors && touched && errors[id] && touched[id];
  const autocompleteIconClassName =
    "autocomplete-icon" + (disabled ? "--disabled" : "");

  return (
    <Autocomplete
      {...props}
      disabled={disabled}
      placeholder={placeholder}
      label={placeholder}
      className={className}
      value={values[id]}
      openOnFocus={false}
      getOptionSelected={(
        option: any, value: any
      ) => {
        return option.code === value;
      }}
      id={id}
      onChange={(
        e: any, newValue: any
      ) => {
        setFieldValue(
          id,
          newValue ? newValue.code : null
        );
      }}
      getOptionLabel={(value: any) => {
        let selectedOption = options.find((option: any) => option.code === value);
        return selectedOption && selectedOption.label
          ? selectedOption.label
          : "";
      }}
      filterOptions={filterOptions}
      options={options}
      renderOption={(option: any) =>
        <React.Fragment>
          {getIcon ?
            <span style={{ marginRight: 8 }}>{getIcon(option.code)}</span>
            :
            <></>
          }
          {option.label}
        </React.Fragment>
      }
      renderInput={(params: any) =>
        <div className={className + (showIcon ? " autocomplete-wrapper-with-icons" : "")}>
          <span className="autocomplete-icon-container">
            <span className={autocompleteIconClassName}>
              {showIcon ? getIcon(values[id]) : null}
            </span>
          </span>
          <TextField
            {...params}
            disabled={disabled}
            variant="outlined"
            required={!disabled}
            label={placeholder}
            placeholder={placeholder}
            error={isValidationFailed}
            helperText={isValidationFailed ? errors[id] : ""}
            autoComplete="new-password"
          />
        </div>
      }
    />
  );
};
